// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__djZ22","pagination__text":"pagination_pagination__text__blc93","pagination__text_between":"pagination_pagination__text_between__43I-5"};